import { FileInput, Grid, Select } from '@mantine/core';
import { useMessageEditorFormContext } from './context.ts';
import { SegmentType, SegmentBuiltinCondition } from '../model';
import { ComponentProps } from 'react';

const SEGMENT_BUILTIN_CONDITION_OPTIONS: Array<{
  label: string;
  value: SegmentBuiltinCondition;
}> = [
  {
    value: 'all_user',
    label: '所有用戶',
  },
];

const ConditionSelector = (props: ComponentProps<typeof Select>) => {
  return (
    <Select
      {...props}
      placeholder="請選擇用戶標籤"
      label={'選擇標籤'}
      data={SEGMENT_BUILTIN_CONDITION_OPTIONS}
      withAsterisk
    />
  );
};

const SEGMENT_TYPE_OPTIONS: Array<{
  label: string;
  value: SegmentType;
}> = [
  {
    value: 'list_segment',
    label: '指定名單',
  },
  {
    value: 'condition_segment',
    label: '用戶標籤',
  },
] as const;

export const TargetSelector = () => {
  const form = useMessageEditorFormContext();

  const segmentSetting = form.getValues().segment;

  const appendix = (() => {
    if (segmentSetting?.type === 'list_segment') {
      return (
        // TODO
        <FileInput
          name="target.annex"
          accept="text/csv"
          label="上傳用戶 csv 檔案"
          placeholder="Upload files"
          key={form.key('segment.file')}
          {...form.getInputProps('segment.file')}
        />
      );
    }

    if (segmentSetting?.type === 'condition_segment') {
      return (
        <ConditionSelector
          key={form.key('segment.condition')}
          {...form.getInputProps('segment.condition')}
        />
      );
    }

    return null;
  })();

  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Select
          label="發送對象"
          withAsterisk
          allowDeselect={false}
          placeholder="請選擇發送對象"
          data={SEGMENT_TYPE_OPTIONS}
          key={form.key('segment.type')}
          {...form.getInputProps('segment.type')}
          onChange={(value) => {
            if (value === 'list_segment') {
              form.setFieldValue('segment', {
                type: 'list_segment',
              });
            }
            if (value === 'condition_segment') {
              form.setFieldValue('segment', {
                type: 'condition_segment',
                condition: 'all_user',
              });
            }
          }}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6 }}>{appendix}</Grid.Col>
    </Grid>
  );
};
